import { render, staticRenderFns } from "./ClientProfileLooseBills.vue?vue&type=template&id=53b0200b&scoped=true&"
import script from "./ClientProfileLooseBills.vue?vue&type=script&lang=js&"
export * from "./ClientProfileLooseBills.vue?vue&type=script&lang=js&"
import style0 from "./ClientProfileLooseBills.vue?vue&type=style&index=0&id=53b0200b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53b0200b",
  null
  
)

export default component.exports